import {
  cordinatesInventory,
  getActionsTemplate,
  statusCheckbox,
  checkBody,
} from './BodyTemplatesTable';
import { Tooltip } from 'primereact/tooltip';
import { LuAlertCircle } from 'react-icons/lu';

export const columnsTableInventory = [
  {
    field: 'SamId',
    header: 'SAM ID',
    sortable: true,
    width: '100px',
    isFilter: true,
    filter: true,
    dataType: undefined,
  },
  {
    field: 'LocationId',
    header: 'Id Location',
    sortable: true,
    width: '100px',
    isFilter: true,
    filter: true,
    dataType: undefined,
  },
  {
    field: 'NumberDevice',
    header: 'Id Lector',
    sortable: true,
    isFilter: true,
    width: '100px',
    filter: true,
    dataType: undefined,
  },
  {
    field: 'SamStatus',
    header: 'Estatus',
    sortable: true,
    body: statusCheckbox,
    width: '100px',
    isFilter: true,
    dataType: 'boolean',
  },
  {
    field: 'WhiteList',
    header: 'Lista blanca',
    width: '100px',

    sortable: true,
    body: checkBody,
    isFilter: true,
    dataType: 'boolean',
  },
  {
    field: 'DeviceType',
    header: 'Dispositivo',
    sortable: true,
    isFilter: true,
    filter: true,
    width: '100px',
    dataType: undefined,
  },
  {
    field: 'SamType',
    header: 'Tipo de SAM',
    sortable: true,
    isFilter: true,
    filter: true,
    width: '100px',
    dataType: undefined,
  },
  {
    field: 'KeyVersion',
    header: 'Ver. llave',
    sortable: true,
    isFilter: true,
    filter: true,
    width: '100px',
    dataType: undefined,
  },
  {
    field: 'LocationGpsObject',
    header: 'Coordenadas',
    sortable: false,
    isFilter: false,
    filter: true,
    width: '100px',
    dataType: undefined,
    body: cordinatesInventory,
  },
  {
    field: 'TechnologicalOperator',
    header: 'Operador',
    sortable: true,
    isFilter: true,
    filter: true,
    width: '100px',
    dataType: undefined,
  },
  {
    field: 'TransportCompanyEUR',
    header: 'Compañía - EUR',
    sortable: true,
    isFilter: true,
    filter: true,
    dataType: undefined,
    width: '100px',
  },
];

export const initColumnsFilters = [
  {
    field: 'SamId',
    header: 'SAM ID',
  },
  {
    field: 'LocationId',
    header: 'Id Location',
  },
  {
    field: 'NumberDevice',
    header: 'Id Lector',
  },
  {
    field: 'SamStatus',
    header: 'Estatus',
  },
  {
    field: 'WhiteList',
    header: 'Lista blanca',
  },
  {
    field: 'DeviceType',
    header: 'Dispositivo',
  },
  {
    field: 'SamType',
    header: 'Tipo de SAM',
  },
  {
    field: 'KeyVersion',
    header: 'Ver. llave',
  },
  {
    field: 'LocationGpsObject',
    header: 'Coordenadas',
  },
  {
    field: 'TechnologicalOperator',
    header: 'Operador',
  },
  {
    field: 'TransportCompanyEUR',
    header: 'Compañía - EUR',
  },
];
export const columnsTableInventoryFilter = [
  {
    field: 'SamId',
    header: 'SAM ID',
  },
  {
    field: 'LocationId',
    header: 'Id Location',
  },
  {
    field: 'NumberDevice',
    header: 'Id Lector',
  },
  {
    field: 'SamStatus',
    header: 'Estatus',
  },
  {
    field: 'WhiteList',
    header: 'Lista blanca',
  },
  {
    field: 'DeviceType',
    header: 'Dispositivo',
  },
  {
    field: 'SamType',
    header: 'Tipo de SAM',
  },
  {
    field: 'KeyVersion',
    header: 'Ver. llave',
  },
  {
    field: 'LocationGpsObject',
    header: 'Coordenadas',
  },
  {
    field: 'TechnologicalOperator',
    header: 'Operador',
  },
  {
    field: 'TransportCompanyEUR',
    header: 'Compañía - EUR',
  },
  {
    field: 'Project',
    header: 'Proyecto',
  },
  {
    field: 'Station',
    header: 'Estación',
  },
  {
    field: 'RouteName',
    header: 'Ruta',
  },
  {
    field: 'RouteNumber',
    header: 'Número de ruta',
  },
  {
    field: 'PointOfSale',
    header: 'Punto de venta',
  },
  {
    field: 'AmountTransactionAdditional',
    header: 'Contadores',
  },
  {
    field: 'PcModules',
    header: 'Módulo Pc',
  },
  {
    field: 'Observations',
    header: 'Observaciones',
  },
  {
    field: 'Name',
    header: 'Usuario que registró',
  },
  {
    field: 'CreatedOn',
    header: 'Fecha de alta',
  },
  {
    field: 'SamActivatedBy',
    header: 'Usuario que activó',
  },
  {
    field: 'ActivatedOn',
    header: 'Fecha de activación',
  },
];

export function createInventoryColumnsTable(
  service: any,
  columnsFilter: boolean = false
) {
  const actionColumn = {
    field: 'acciones',
    header: 'Acciones',
    sortable: false,
    isFilter: false,
    dataType: undefined,
    body: getActionsTemplate(
      service.editSamHandler,
      service.openDisableSam,
      service.openWhiteListSam,
      service.openRechargesCounterModalSingle,
      service.openTriggerCommunicationModalSingle
    ),
  };

  const _columnsInFilterInventory = columnsInFilterInventory(service);
  const _filteredColumns = [
    ...columnsTableInventory,
    ..._columnsInFilterInventory,
  ].filter(col =>
    service.columnsSelected.some(
      (selected: any) => selected.field === col.field
    )
  );
  const filteredColumns = columnsFilter
    ? _filteredColumns
    : [..._filteredColumns, , actionColumn];
  return filteredColumns;
}

const rechargesCounterInventory = (row: any, service: any) => {
  return row.AmountTransactionAdditional !== null ? (
    <div
      className="flex w-full text-base"
      onClick={() => service.openAddContadortes(row)}>
      <p>{row.AmountTransactionAdditional}</p>
      <>
        <Tooltip target=".custom-target-icon" />
        <div
          className="custom-target-icon"
          data-pr-tooltip={'Historial de contadores'}
          data-pr-position="top">
          <LuAlertCircle className="text-sm text-ligth_blue cursor-pointer ml-2" />
        </div>
      </>
    </div>
  ) : (
    <></>
  );
};

export const columnsDisplayRechargeCounterHistory = [
  {
    field: 'createdDate',
    header: 'Fecha',
    sortable: true,
  },
  {
    field: 'createdBy',
    header: 'Operador',
    sortable: true,
  },
  {
    field: 'amount',
    header: 'Cantidad',
    sortable: true,
  },
  {
    field: 'address',
    header: 'Dirección',
    sortable: true,
  },
];

export function columnsInFilterInventory(service: any) {
  return [
    {
      field: 'Project',
      header: 'Proyecto',
      sortable: true,
      isFilter: true,
      filter: true,
      dataType: undefined,
      width: '100px',
    },
    {
      field: 'Station',
      header: 'Estación',
      sortable: true,
      isFilter: true,
      filter: true,
      dataType: undefined,
      width: '100px',
    },
    {
      field: 'RouteName',
      header: 'Ruta',
      sortable: true,
      isFilter: true,
      filter: true,
      dataType: undefined,
      width: '100px',
    },
    {
      field: 'RouteNumber',
      header: 'Número de ruta',
      sortable: true,
      isFilter: true,
      filter: true,
      dataType: undefined,
      width: '100px',
    },
    {
      field: 'PointOfSale',
      header: 'Punto de venta',
      sortable: true,
      isFilter: true,
      filter: true,
      dataType: undefined,
      width: '100px',
    },
    {
      field: 'AmountTransactionAdditional',
      header: 'Contadores',
      isFilter: false,
      sortable: false,
      filter: true,
      dataType: undefined,
      width: '100px',
      body: (row: any) => rechargesCounterInventory(row, service),
    },
    {
      field: 'PcModules',
      header: 'Módulo Pc',
      sortable: true,
      isFilter: true,
      width: '100px',
      filter: true,
      dataType: undefined,
    },
    {
      field: 'Observations',
      header: 'Observaciones',
      sortable: true,
      isFilter: true,
      width: '100px',
      filter: true,
      dataType: undefined,
    },
    {
      field: 'Name',
      header: 'Usuario que registró',
      sortable: true,
      isFilter: true,
      filter: true,
      width: '100px',
      dataType: undefined,
    },
    {
      field: 'CreatedOn',
      header: 'Fecha de alta',
      sortable: true,
      isFilter: true,
      filter: true,
      width: '100px',
      dataType: 'date',
    },
    {
      field: 'SamActivatedBy',
      header: 'Usuario que activó',
      sortable: true,
      isFilter: true,
      width: '100px',
      filter: true,
      dataType: undefined,
    },
    {
      field: 'ActivatedOn',
      header: 'Fecha de activación',
      sortable: true,
      isFilter: true,
      filter: true,
      dataType: 'date',
      width: '100px',
    },
  ];
}
